<template>
    <div id="service-content" class="p-6">
        <div slot="header" class="flex justify-between pb-base">
            <h3 class="font-bold">Custom</h3>
        </div>

        <div class="service-list-content">
            <div class="service-header flex p-6 text-sm font-bold">
                <div class="w-1/12 px-2"></div>
                <div class="w-3/12 px-2 text-uppercase">Service Name</div>
                <div class="w-2/12 px-2 text-uppercase text-center">Price</div>
                <div class="w-2/12 px-2 text-uppercase text-center">Duration</div>
                <div class="w-2/12 px-2 text-uppercase text-center">Active</div>
                <div class="w-2/12 px-2 text-uppercase text-center">Action</div>
            </div>
            <!-- <draggable v-model="dragList" :scroll-sensitivity="250" :force-fallback="true" :options="{handle:'.move-btn'}" @end="getOrderList" v-if="dragList && dragList.length > 0 && !isEmptyList">
                <transition-group>
                <div class="service-item flex align-center p-5 mb-5 shadow-sm" v-for="item in dragList" :key="item.id" @click="editService(item)">
                    <div class="w-1/12 px-2 leading-none">
                        <feather-icon icon="MoveIcon" svgClasses="w-5 stroke-current cursor-pointer icon-group move-btn"/>
                    </div>
                    <div class="w-3/12 px-2">
                        <p class="product-name font-medium truncate service-name">{{item.name}}</p>
                    </div>
                    <div class="w-2/12 px-2">
                        <div v-if="item.price != null">
                            <p class="product-name font-medium truncate text-center">${{item.price}}</p>
                        </div>
                        <div v-else>
                            <p class="product-name font-medium truncate text-center">N/A</p>
                        </div>
                    </div>
                    <div class="w-2/12 px-2">
                        <div v-if="item.duration != null">
                            <p class="product-name font-medium truncate text-center">{{item.duration}}</p>
                        </div>
                        <div v-else>
                            <p class="product-name font-medium truncate text-center">N/A</p>
                        </div>
                    </div>
                    <div class="w-2/12 px-2">
                        <div class="text-center" v-if="item.status == 1">
                            <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary" />
                        </div>
                        <div class="text-center" v-else>
                            <feather-icon icon="XIcon" svgClasses="w-6 h-6 stroke-current text-danger" />
                        </div>
                    </div>
                    <div class="w-2/12 px-2 flex justify-center">
                        <img src="../../assets/images/trash-icon.png" class="trash-icon cursor-pointer" @click.stop="openDeleteServicePopup(item)" />
                    </div>
                </div>
                </transition-group>
            </draggable> -->
            <div class="p-base text-center">
                No data available
            </div>
        </div>
        <vs-popup class="holamundo delete-group delete-popup" title="Delete Service" :active.sync="popupActive">
            <div class="text-center">
                <h3>Do you want to delete this service?</h3>
                <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                <vs-button class="mr-6 align-center delete-responsive">Delete</vs-button>
                <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupActive = false">Cancel</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    name: 'custom-content',
    data() {
        return {
            popupActive: false
        }
    }
}
</script>